import { render } from "./dashboard_simple.vue?vue&type=template&id=ef5fd300&scoped=true"
import script from "./dashboard_simple.vue?vue&type=script&lang=js"
export * from "./dashboard_simple.vue?vue&type=script&lang=js"

import "./dashboard_simple.vue?vue&type=style&index=0&id=ef5fd300&scoped=true&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef5fd300"]])

export default __exports__